// Design system configuration
export const designConfig = {
  colors: {
    flarionYellow: '#FDFF37',
    snowWhite: '#FFFAFA',
    offBlack: '#1A1A1A',
    darkBackground: '#121212',
    darkBackgroundSecondary: '#1F2937',
    lightBackground: '#FFFFFF',
    lightBackgroundSecondary: '#F8F9FA',
    
    // Accent colors
    success: '#10B981',
    warning: '#F59E0B',
    error: '#EF4444',
    info: '#3B82F6',
    
    // Text colors
    textDark: {
      primary: '#FFFFFF',
      secondary: '#E1E1E6',
      tertiary: '#A3A3A3'
    },
    textLight: {
      primary: '#000000',
      secondary: '#333333',
      tertiary: '#666666'
    },
    
    // Branding color palette
    palette: {
      oliveGreen: '#9DA000',
      mediumYellow: '#E6E800',
      lightOrange: '#FFDD9A',
      orange: '#FFA800',
      lightGray: '#BFC3CD'
    },
    
    // Chart and visualization colors referencing the palette values
    get chartColors() {
      return [
        this.palette.orange,
        this.palette.oliveGreen,
        this.palette.mediumYellow,
        this.palette.lightOrange,
        this.palette.lightGray
      ];
    }
  },
  
  typography: {
    fontFamily: '"ID Grotesk", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    fontSizes: {
      xs: 12,
      sm: 14,
      base: 16,
      lg: 18,
      xl: 20,
      '2xl': 24,
      '3xl': 30,
      '4xl': 36
    },
    fontWeights: {
      normal: 250,
      medium: 350,
      semibold: 450,
      bold: 550
    },
    lineHeights: {
      tight: 1.2,
      normal: 1.5,
      loose: 1.8
    }
  },
  
  spacing: {
    base: 4,
    get xs() { return this.base * 1 },    // 4px
    get sm() { return this.base * 2 },    // 8px
    get md() { return this.base * 4 },    // 16px
    get lg() { return this.base * 6 },    // 24px
    get xl() { return this.base * 8 },    // 32px
    get '2xl'() { return this.base * 12 }, // 48px
    get '3xl'() { return this.base * 16 }  // 64px
  },
  
  radius: {
    sm: 4,
    md: 8,
    lg: 12,
    xl: 16,
    full: 9999
  },

  // Font size multiplier for responsive scaling
  fontSizeMultiplier: 1,
  
  // Layout and margins
  layout: {
    margins: {
      title: 4,      // 16px title bottom margin
      section: 6,    // 24px section bottom margin
      content: 4,    // 16px content padding
      component: 6   // 24px component padding
    },
    padding: {
      card: 6        // 24px card padding
    }
  },

  // Helper function to get theme-dependent values
  getThemeValue: (theme: string, lightValue: string | number | object, darkValue: string | number | object): string | number | object => {
    return theme === 'dark' ? darkValue : lightValue;
  }
};